import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  viewBox: "0 0 136 133",
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M67.867 0C30.387 0 0 30.388 0 67.875c0 29.988 19.446 55.425 46.417 64.404 3.396.621 4.633-1.475 4.633-3.275 0-1.608-.058-5.879-.092-11.541-18.879 4.1-22.862-9.1-22.862-9.1-3.088-7.842-7.538-9.93-7.538-9.93-6.162-4.208.467-4.125.467-4.125 6.813.48 10.396 6.996 10.396 6.996 6.054 10.371 15.887 7.375 19.754 5.638.617-4.384 2.367-7.375 4.308-9.071-15.07-1.713-30.916-7.538-30.916-33.546 0-7.408 2.646-13.467 6.987-18.212-.7-1.717-3.029-8.617.663-17.963 0 0 5.7-1.825 18.666 6.958 5.413-1.508 11.221-2.258 16.992-2.283 5.763.025 11.571.775 16.992 2.283 12.958-8.783 18.646-6.958 18.646-6.958 3.704 9.346 1.375 16.246.674 17.963 4.35 4.745 6.98 10.804 6.98 18.212 0 26.075-15.871 31.813-30.992 33.492 2.438 2.096 4.608 6.237 4.608 12.571 0 9.07-.083 16.391-.083 18.616 0 1.817 1.221 3.929 4.667 3.267 26.95-8.996 46.379-34.417 46.379-64.396C135.746 30.388 105.354 0 67.867 0" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }